export const toHtmlId = (id: string) => {
  const parts = id.split(":");
  if (parts.length === 4) {
    return parts[3];
  }

  return id;
};
